import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import styles from './index.module.scss';

export default function Comp() {
    return (
        <div className={styles.comp} id="SectionD">
            <EcoSpace />
            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1745224596306/d.jpg" pad="https://websiteoss.ecoflow.com/upload/image/1745224596306/d.jpg" h5="https://websiteoss.ecoflow.com/upload/image/1745224673100/d-h5.jpg" />
            <EcoSpace />
        </div>
    );
}
